/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SquareLeaderboardResult_getSquareLeaderboardData$ref: FragmentReference;
declare export opaque type SquareLeaderboardResult_getSquareLeaderboardData$fragmentType: SquareLeaderboardResult_getSquareLeaderboardData$ref;
export type SquareLeaderboardResult_getSquareLeaderboardData = {|
  +getSquareLeaderboardData: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +_id: ?string,
      +game_id: ?number,
      +event_id: ?number,
      +leaderboard_link: ?string,
      +rowarr: ?$ReadOnlyArray<?number>,
      +colarr: ?$ReadOnlyArray<?number>,
      +answers: ?$ReadOnlyArray<?{|
        +_id: ?string,
        +guest_name: ?string,
        +guest_id: ?number,
        +square: ?string,
        +winner: ?boolean,
      |}>,
    |},
  |},
  +$refType: SquareLeaderboardResult_getSquareLeaderboardData$ref,
|};
export type SquareLeaderboardResult_getSquareLeaderboardData$data = SquareLeaderboardResult_getSquareLeaderboardData;
export type SquareLeaderboardResult_getSquareLeaderboardData$key = {
  +$data?: SquareLeaderboardResult_getSquareLeaderboardData$data,
  +$fragmentRefs: SquareLeaderboardResult_getSquareLeaderboardData$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "_id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SquareLeaderboardResult_getSquareLeaderboardData",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "question_leaderboard_link",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "getSquareLeaderboardData",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "question_leaderboard_link",
          "variableName": "question_leaderboard_link"
        }
      ],
      "concreteType": "squareLeaderboardDataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "data",
          "storageKey": null,
          "args": null,
          "concreteType": "square_question_type",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "game_id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "event_id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "leaderboard_link",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "rowarr",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "colarr",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "answers",
              "storageKey": null,
              "args": null,
              "concreteType": "square_answer_type",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "guest_id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "square",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "winner",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '61bef0fd9cfe97b10300811bd3eeb305';
module.exports = node;
